import {
    CarDetailsType,
    DisplayedCarInfoInterface,
    ExperimentShowFinancingButton,
} from '@/types';
import Typography from '../../../shared/typography/typography.component';
import { TFunction } from 'i18next';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { GreenInfo } from 'public/Images';
import { getRequiredCTAs } from './helper';
import { CarProfileCTAs } from './AvailableActions';
import { AvailableCTAs } from './CarCTAs.enum';

const MobileButtons = ({
    carInfo,
    requiredCTAs,
    financingSource,
}: {
    carInfo: DisplayedCarInfoInterface;
    requiredCTAs: AvailableCTAs[];
    financingSource?: string;
}) => {
    if (carInfo?.isSold || carInfo?.isPurchaseInProgress) {
        return;
    }
    return (
        <div className="md:hidden w-full sticky bottom-0 bg-white px-3 py-4 shadow-[0px_24px_48px_-12px_rgba(16,24,40,0.18)] border-t border-[#EAECF0] z-[2] flex items-center gap-[14px] h-[98px]">
            {requiredCTAs.map(cta => {
                const CtaComponent = CarProfileCTAs[cta];
                return CtaComponent ? (
                    <div className="w-full h-[80%]">
                        <CtaComponent
                            key={cta}
                            carInfo={carInfo}
                            financingSource={financingSource}
                        />
                    </div>
                ) : null;
            })}
        </div>
    );
};
const DesktopButtons = ({
    carInfo,
    requiredCTAs,
    financingSource,
}: {
    carInfo: DisplayedCarInfoInterface;
    requiredCTAs: AvailableCTAs[];
    financingSource?: string;
}) => {
    return (
        carInfo && (
            <div className={'flex items-center gap-4 h-[50px] md:h-[60px]  '}>
                {requiredCTAs.map(cta => {
                    const CtaComponent = CarProfileCTAs[cta];
                    return CtaComponent ? (
                        <div className="w-full h-full">
                            <CtaComponent
                                key={cta}
                                carInfo={carInfo}
                                financingSource={financingSource}
                            />
                        </div>
                    ) : null;
                })}
            </div>
        )
    );
};

const CarCTAs = ({
    carInfo,
    t,
    IS_DESKTOP,
    showTip,
    financingSource,
}: {
    carInfo: DisplayedCarInfoInterface | CarDetailsType;
    t: TFunction<'translation', undefined>;
    IS_DESKTOP: boolean;
    showTip?: boolean;
    financingSource?: string;
}) => {
    //FINANCING BTN AB TESTING ================
    const FEATURE_FLAG_SHOW_FINANCING_BUTTON = 'show-financing-button';

    const showFinancingButtonExperiment = useFeatureValue(
        FEATURE_FLAG_SHOW_FINANCING_BUTTON,
        ExperimentShowFinancingButton.ORIGINAL
    );
    const [showFinancingButton, setShowFinancingButton] = useState<boolean>();

    useEffect(() => {
        if (showFinancingButtonExperiment) {
            setShowFinancingButton(
                showFinancingButtonExperiment !==
                    ExperimentShowFinancingButton.HIDE
            );
        }
    }, [showFinancingButtonExperiment]);
    // ================================================
    const requiredCTAs: AvailableCTAs[] = getRequiredCTAs(
        carInfo as DisplayedCarInfoInterface,
        showFinancingButton
    );
    return (
        <>
            {!IS_DESKTOP ? (
                <MobileButtons
                    carInfo={carInfo as DisplayedCarInfoInterface}
                    requiredCTAs={requiredCTAs}
                    financingSource={financingSource}
                />
            ) : (
                <>
                    <DesktopButtons
                        carInfo={carInfo as DisplayedCarInfoInterface}
                        requiredCTAs={requiredCTAs}
                        financingSource={financingSource}
                    />

                    {requiredCTAs.includes(AvailableCTAs.NOTIFY_ME) &&
                        showTip && (
                            <div
                                className={
                                    'flex p-2.5 bg-success-50 rounded-lg gap-1.5 items-start content-center justify-center w-full'
                                }
                            >
                                <Image
                                    src={GreenInfo}
                                    alt="GreenInfo"
                                    width={20}
                                    height={20}
                                />
                                <Typography
                                    variant="captionMedium"
                                    className={'text-success-600'}
                                >
                                    {t(
                                        'Clicking on Notify Me will send you a message once the the car is open for reservation again'
                                    )}
                                </Typography>
                            </div>
                        )}
                </>
            )}
        </>
    );
};
export default CarCTAs;
